export default '/static/frontend/ReachDigital/12gobiking/dist/assets/bancontact-wit-65d7869e.svg'